(() => {
  if (window.icafePanelsReady) return;
  window.icafePanelsReady = true;
  document.addEventListener('click', (event) => {
    const filter = event.target.closest('[data-ic-filter]');
    if (filter) {
      const panel = filter.closest('[data-ic-panel]');
      panel.querySelectorAll('[data-ic-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      panel.querySelectorAll('[data-ic-group]').forEach(card => { card.hidden = filter.dataset.icFilter !== 'all' && card.dataset.icGroup !== filter.dataset.icFilter; });
    }
    const arrow = event.target.closest('[data-ic-scroll]');
    if (arrow) {
      const track = arrow.closest('[data-ic-panel]').querySelector('[data-ic-track]');
      const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      track.scrollBy({left: direction * track.clientWidth * (arrow.dataset.icScroll === 'next' ? 1 : -1), behavior: motion});
    }
  });
})();

(() => {
  if (window.icafeCROReady) return;
  window.icafeCROReady = true;
  document.addEventListener('click', event => {
    const choice = event.target.closest('[data-roast],[data-blend]');
    if (!choice) return;
    const finder = choice.closest('[data-ic-finder]');
    if (!finder) return;
    const attribute = choice.hasAttribute('data-roast') ? 'data-roast' : 'data-blend';
    finder.querySelectorAll(`[${attribute}]`).forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
    const roast = finder.querySelector('[data-roast][aria-pressed="true"]').dataset.roast;
    const blend = finder.querySelector('[data-blend][aria-pressed="true"]').dataset.blend;
    finder.querySelectorAll('[data-finder-result]').forEach(result => { result.hidden = result.dataset.finderResult !== `${roast}-${blend}`; });
  });

})();
document.addEventListener('change', event => {
  if (!event.target.matches('[data-cross-variant]')) return;
  const price = event.target.closest('.ic-cross-card').querySelector('[data-cross-price]');
  if (price) price.textContent = event.target.selectedOptions[0].dataset.money;
});
(() => {
  if (window.icafeStickyReady) return;
  window.icafeStickyReady = true;
  let pending = false;
  const update = () => {
    pending = false;
    const sticky = document.querySelector('hdt-sticky-btn-atc');
    if (!sticky) return;
    const form = document.getElementById(sticky.getAttribute('form'));
    if (!form) return;
    const footer = document.querySelector('footer');
    const formRect = form.getBoundingClientRect();
    const visible = (formRect.bottom < 0 || (innerWidth < 768 && formRect.top > innerHeight)) && (!footer || footer.getBoundingClientRect().top > innerHeight);
    sticky.classList.add('ic-sticky-managed');
    sticky.classList.toggle('ic-sticky-visible', visible);
    sticky.setAttribute('aria-hidden', String(!visible));
    sticky.inert = !visible;
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
})();

(() => {
  if (window.icafeEditorialReady) return;
  window.icafeEditorialReady = true;
  const headerState = () => document.body.classList.toggle('ic-header-scrolled', window.scrollY > 32);
  addEventListener('scroll', headerState, { passive: true });
  addEventListener('pageshow', headerState);
  headerState();
  document.addEventListener('click', event => {
    const category = event.target.closest('[data-ic-category-filter]');
    if (!category) return;
    const panel = category.closest('[data-ic-panel]');
    panel.querySelectorAll('[data-ic-filter],[data-ic-category-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === category)));
    panel.querySelectorAll('[data-ic-category]').forEach(card => { card.hidden = card.dataset.icCategory !== category.dataset.icCategoryFilter; });
  });

})();
